/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: 1,
    categoryName: "Self Help",
    value: "SELF_HELP",
    image:
      "https://planit-shopit.netlify.app/static/media/self%20help.eab437eb.jpeg",
  },
  {
    _id: 2,
    categoryName: "Literature",
    value: "LITERATURE",
    image:
      "https://th.bing.com/th/id/OIP.dGgA6J7Z2Sf44HLbiSCKiAHaE8?pid=ImgDet&w=600&h=400&rs=1",
  },
  {
    _id: 3,
    categoryName: "Biographies",
    value: "BIOGRAPHIES",
    image: "https://planit-shopit.netlify.app/static/media/bio.5060198c.jpeg",
  },
  {
    _id: 4,
    categoryName: "Spirituality",
    value: "SPIRITUALITY",
    image:
      "https://planit-shopit.netlify.app/static/media/spiritual.a662fb54.jpeg",
  },
  {
    _id: 5,
    categoryName: "Science Fiction",
    value: "SCIENCE_FICTION",
    image:
      "https://toptenfamous.com/wp-content/uploads/2021/05/science-fiction-1536x960.jpg",
  },
  {
    _id: 6,
    categoryName: "Mythology",
    value: "MYTHOLOGY",
    image:
      "https://planit-shopit.netlify.app/static/media/history.0c02ce5c.jpeg",
  },
  {
    _id: 7,
    categoryName: "Contemporary Fiction",
    value: "CONTEMPORARY_FICTION",
    image:
      "https://planit-shopit.netlify.app/static/media/book%20cluster.f4d4b878.jpeg",
  },
  {
    _id: 8,
    categoryName: "Psychological Thriller",
    value: "PSYCHOLOGICAL_THRILLER",
    image:
      "https://the-bibliofile.com/wp-content/uploads/psychologicalthrillers2-768x768.jpg",
  },
];
